import Tod1 from "./19.webp";
import Tod2 from "./20.webp";

const todimages = [Tod1, Tod2];

export default todimages;
